import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Stack,
  Flex,
  Text,
  Input,
  Checkbox,
  Box,
} from "@chakra-ui/react";
import React from "react";
import { BsFacebook, BsApple } from "react-icons/bs";
import { FcGoogle } from "react-icons/fc";
import JoinPopup from "./JoinPopup";
export default function SignInPopup({ children,view,setView }) {
  const handleOpen = ()=>{
    setView("sign");
  }
  const handleClose = ()=>{
    setView("");
  }
  return (
    <>
      {children ? (
        <Box onClick={handleOpen} cursor="pointer">{children}</Box>
      ) : (
        <Button size="sm" bg="transparent"  onClick={handleOpen} >
          <Text color="gray">Sign in</Text>
        </Button>
      )}
      <Modal isOpen={view} onClose={handleClose} isCentered size="xl">
        <ModalOverlay />
        <ModalContent pt={6} mx={2} maxHeight="80vh">
          <ModalHeader
            fontSize={{ base: "18px", md: "32px" }}
            fontWeight="semibold"
            align="center"
          >
            Join Decolance
          </ModalHeader>
          <ModalCloseButton
          id="sign-close"
            mt={{ base: 8, md: 10 }}
            mr={{ sm: 6 }}
            bg="#c5c5c5"
            color="white"
            borderRadius="20px"
          />
          <ModalBody overflowY="auto" maxHeight="100vh">
            <Stack pt={2} px={{ sm: 12 }} gap={{ base: 2, md: 4 }}>
              <Button borderRadius={10} bg="#4267B2" color="white" py={6}>
                <Flex
                  fontSize={{ base: "14px", md: "17px" }}
                  justifyContent="center"
                  align="center"
                  gap={{ base: 2, md: 8 }}
                >
                  <BsFacebook size="24px" />
                  <Text w={{ base: "160px", sm: "200px" }} align="start">
                    Sign In with Facebook
                  </Text>
                </Flex>
              </Button>
              <Button
                borderRadius={10}
                bg="white"
                border="1px"
                borderColor="#c5c5c5"
                py={6}
              >
                <Flex
                  fontSize={{ base: "14px", md: "17px" }}
                  justifyContent="center"
                  align="center"
                  gap={{ base: 4, md: 10 }}
                >
                  <FcGoogle size="24px" />
                  <Text w={{ base: "160px", sm: "200px" }} align="start">
                    Sign In with Google
                  </Text>
                </Flex>
              </Button>
              <Button
                borderRadius={10}
                bg="white"
                border="1px"
                borderColor="#c5c5c5"
                py={6}
              >
                <Flex
                  fontSize={{ base: "14px", md: "17px" }}
                  justifyContent="center"
                  align="center"
                  gap={{ base: 4, md: 10 }}
                >
                  <BsApple size="24px" />
                  <Text w={{ base: "160px", sm: "200px" }} align="start">
                    Sign In with Apple
                  </Text>
                </Flex>
              </Button>
              <Text
                align="center"
                fontSize={{ base: "18px", md: "23px" }}
                fontWeight="semibold"
              >
                OR
              </Text>
              <Input placeholder="Email / Username" py={4} />
              <Input placeholder="Password" py={4} />
              <Button bg="brand.500" color="white" py={4}>
                Continue
              </Button>
            </Stack>
            <Flex justify="space-between" px={{ sm: 12 }} py={2} mt={2} mb={4}>
              <Checkbox defaultChecked colorScheme="gray">
                <Text fontSize={{ base: "12px", sm: "16px" }}>Remember Me</Text>
              </Checkbox>
              <Text
                align="center"
                color="brand.500"
                fontSize={{ base: "12px", sm: "16px" }}
              >
                Forget Password?
              </Text>
            </Flex>
          </ModalBody>

          <ModalFooter
            borderTop="1px"
            borderColor="#c5c5c5"
            flexDirection={"column"}
            gap={2}
          >
            <Text
              align="center"
              color="#727272"
              fontSize="17px"
              fontWeight={"semibold"}
            >
              Not a member yet?
            </Text>
            <JoinPopup >
              <Text
                align="center"
                color="brand.500"
                textDecoration={"underline"}
                onClick={(e)=>{setView("join");e.stopPropagation();}}
              >
                Join Now
              </Text>
            </JoinPopup>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
